/**
 * How long the meeting's signaling socket waits before reconnecting.
 *
 * A socket that was DROPPED (network blip, missed heartbeat, backgrounded tab)
 * should come back quickly: capped exponential backoff, 1 s → 10 s, as before.
 *
 * A socket that is REFUSED — closed before it ever opened, again and again —
 * is being turned away: a token the server will not accept, or a server
 * shedding load. Retrying that every 10 s forever is what turned one slow
 * token mint into 7,697 refused connections in 20 minutes on 2026-10-06, each
 * a TLS handshake and four log lines on signaling, which made the next mints
 * slower still. After a few refusals in a row the cap rises to a minute.
 *
 * Every delay is jittered (between half and all of the step), so a fleet that
 * lost the server together does not hit it again in lockstep.
 */

export const DROP_CAP_MS = 10_000
export const REFUSED_CAP_MS = 60_000
/** Consecutive closes-before-open that count as being refused rather than dropped. */
export const REFUSED_AFTER = 3

export function signalingReconnectDelay(
  attempt: number,
  refusedStreak: number,
  random: () => number = Math.random,
): number {
  const cap = refusedStreak >= REFUSED_AFTER ? REFUSED_CAP_MS : DROP_CAP_MS
  const step = Math.min(1000 * 2 ** Math.max(0, attempt - 1), cap)
  return step / 2 + random() * (step / 2)
}
